export function arraysEqual(a, b, comparator) {
  if (!a || !b) {
    if (a === b) {
      return true; // both falsy
    }
    return false; // one is falsy, the other not
  }

  if (a.length !== b.length) {
    return false; // not equal length
  }
  for (let i = 0; i < a.length; i++) {
    const itemA = a[i];
    const itemB = b[i];
    if (!itemA || !itemB) {
      if (itemA === itemB) {
        continue; // both are falsy
      }
      return false; // one is falsy, the other not
    }
    if (!comparator(itemA, itemB)) {
      return false;
    }
  }
  return true;
}

// get unique items from an array
export function getUniques(array, mapFunction, returnObj) {
  // mapFunction could be a => a.something() if an array of objects or just a => a if a simple array
  const unique = array
    .map(mapFunction)
    // store the keys of the unique objects
    .map((e, i, prevArray) => (prevArray.indexOf(e) === i ? i : false))
    // eliminate the dead keys & store unique objects
    .filter((e) => array[e])
    .map((i) => array[i]);
  if (!returnObj) {
    return unique.map(mapFunction);
  }
  return unique;
}

export function updateArrayElement(originalArray, position, value) {
  const newArray = originalArray.slice();
  if (newArray.length > position) {
    newArray[position] = value;
  }
  return newArray;
}

export function removeItemFromArray(originalArray, itemToRemove) {
  const newArray = originalArray.slice();
  newArray.splice(newArray.indexOf(itemToRemove), 1);
  return newArray;
}

export function addItemToArray(originalArray, item) {
  const newArray = originalArray.slice();
  newArray.push(item);
  return newArray;
}

export function sortArrayOfObj(a, b, key) {
  if (a[key] < b[key]) {
    return -1;
  }
  if (a[key] > b[key]) {
    return 1;
  }
  return 0;
}
